/* eslint-disable eqeqeq */
import {
  faMapMarkerAlt,
  faUser,
  faCirclePlay,
  faCheckCircle,
  faHistory,
  faPhone,
  faArrowRotateLeft,
  faTaxi,
  faRoute,
  faUserTie,
  faUserSlash,
  faUserGear,
  faCircle,
  faPaperPlane,
  faEye,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import {
  faWhatsapp,
  faWaze,
  faGoogle,
  faApple,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  formatDateString,
  formatDateStringWithTime,
  formatRelativeTime,
  isNotEmpty,
} from "../../helpers/general";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CTooltip,
  CNav,
  CNavItem,
  CNavLink,
  CFormCheck,
  CTableDataCell,
  CFormInput,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from "@coreui/react";
import { format } from "date-fns";
import {
  RidecancelReason,
  RidecancelReasonLabels,
  RideFoundDriverSourceLabels,
} from "../../helpers/enums";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apiService from "../../service/apiService";
import { useMutation } from "react-query";
import { useCookie } from "../../hooks/useCookie";
import { map } from "lodash";
import { ProfilePictureAvatar } from "./Profile_picture_avatar";

const eventPresentationInfo: Record<
  | "ride_created"
  | "found_driver"
  | "arrived_at_pickup"
  | "start_ride"
  | "complete_ride"
  | "user_cancel_ride"
  | "driver_cancel_ride"
  | "admin_cancel_ride"
  | "retry_ride_req"
  | "no_driver_found"
  | "initiate_call_driver_whatsapp_call"
  | "initiate_call_driver_phone_call"
  | "initiate_call_user_phone_call"
  | "initiate_call_user_whatsapp_call"
  | "open_navigation_app_driver_waze"
  | "open_navigation_app_driver_google_maps"
  | "open_navigation_app_driver_apple_maps",
  { icon: any; title: string; description?: string; color: string }
> = {
  ride_created: {
    title: "Trajet créé",
    icon: faRoute,
    color: "secondary",
  },
  found_driver: {
    title: "Conducteur trouvé",
    icon: faTaxi,
    color: "danger",
  },
  arrived_at_pickup: {
    title: "Arrivé au point de prise en charge",
    icon: faMapMarkerAlt,
    color: "warning",
  },
  start_ride: {
    title: "Trajet démarré",
    icon: faCirclePlay,
    color: "success",
  },
  complete_ride: {
    title: "Trajet terminé",
    icon: faCheckCircle,
    color: "primary",
  },
  user_cancel_ride: {
    title: "Annulé par utilisateur",
    icon: faUser,
    color: "red",
  },
  driver_cancel_ride: {
    title: "Annulé par le conducteur",
    icon: faUserTie,
    color: "red",
  },
  initiate_call_driver_phone_call: {
    title: "Appel téléphonique au client",
    icon: faPhone,
    color: "info",
  },
  initiate_call_driver_whatsapp_call: {
    title: "Appel WhatsApp au client",
    icon: faWhatsapp,
    color: "info",
  },
  initiate_call_user_phone_call: {
    title: "Appel téléphonique au conducteur",
    icon: faPhone,
    color: "info",
  },
  initiate_call_user_whatsapp_call: {
    title: "Appel WhatsApp au conducteur",
    icon: faWhatsapp,
    color: "info",
  },
  open_navigation_app_driver_waze: {
    title: "Ouverture de Waze",
    icon: faWaze,
    color: "info",
  },
  open_navigation_app_driver_google_maps: {
    title: "Ouverture de Google Maps",
    icon: faGoogle,
    color: "info",
  },
  open_navigation_app_driver_apple_maps: {
    title: "Ouverture de Apple Maps",
    icon: faApple,
    color: "info",
  },
  retry_ride_req: {
    title: "Réessayer le trajet",
    icon: faArrowRotateLeft,
    color: "info",
  },
  no_driver_found: {
    title: "Aucun conducteur trouvé",
    icon: faUserSlash,
    color: "gray",
  },
  admin_cancel_ride: {
    title: "Annulé par l'administrateur",
    icon: faUserGear,
    color: "red",
  },
};

const historyInfoType = ["initiate_call", "open_navigation_app"];
interface HistoryItem {
  itemType: "item" | "info";
  type:
    | "ride_created"
    | "found_driver"
    | "arrived_at_pickup"
    | "start_ride"
    | "complete_ride"
    | "user_cancel_ride"
    | "driver_cancel_ride"
    | "admin_cancel_ride"
    | "initiate_call"
    | "open_navigation_app"
    | "retry_ride_req"
    | "no_driver_found";
  data?: string;
  createdAt: Date;
  secondsSincePreviousEvent: number | null;
  dataKey: string;
}

const RideHistoryTimeline = ({
  ride,
  onFoundDriversChange,
  onShowDriversOnMapChange,
}: {
  ride: Ride;
  onFoundDriversChange: (drivers: RideDriverLog[]) => void;
  onShowDriversOnMapChange: (showDriversOnMap: Record<string, boolean>) => void;
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const { token } = useCookie("vToken");
  const [foundDrivers, setFoundDrivers] = useState<RideDriverLog[]>([]);
  const [onLine, setOnLine] = useState<boolean | null>(true);
  const [showDriversOnMap, setShowDriversOnMap] = useState<
    Record<string, boolean>
  >({});
  const [search, setSearch] = useState("");
  const handleTabChange = (tab: number) => {
    setActiveTab(tab);
  };
  const getFoundDrivers = useMutation((rideId: string) => {
    return apiService.MakeGetRequest(
      `rides/${rideId}/found-drivers-logs`,
      token,
    );
  });
  useEffect(() => {
    setFoundDrivers([]);
    getFoundDrivers.mutate(ride.id, {
      onSuccess: (data) => {
        const drivers = data.items as RideDriverLog[];
        setFoundDrivers(drivers);
        onFoundDriversChange?.(drivers);
      },
      onError: (error) => {
        console.log(error);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ride.id, onFoundDriversChange]);

  const handleShowDriversOnMap = (driverId: string, checked: boolean) => {
    const newShowDriversOnMap = { ...showDriversOnMap, [driverId]: checked };
    setShowDriversOnMap(newShowDriversOnMap);
    onShowDriversOnMapChange?.(newShowDriversOnMap);
  };

  const rideHistoryCopy = [...ride.history];
  rideHistoryCopy.push({
    id: -999,
    rideStatus: "waiting_for_pickup",
    type: "action",
    createdAt: ride.createdAt,
    data: {
      type: "action",
      action: "ride_created",
    },
  });
  const rideHistory: HistoryItem[] = rideHistoryCopy
    .filter(
      (item) =>
        item.type === "action" &&
        item.data?.type === "action" &&
        (item.data.action === "ride_created" ||
          item.data.action === "found_driver" ||
          item.data.action === "arrived_at_pickup" ||
          item.data.action === "start_ride" ||
          item.data.action === "complete_ride" ||
          item.data.action === "user_cancel_ride" ||
          item.data.action === "driver_cancel_ride" ||
          item.data.action === "initiate_call" ||
          item.data.action === "open_navigation_app" ||
          item.data.action === "no_driver_found" ||
          item.data.action === "admin_cancel_ride" ||
          item.data.action === "retry_ride_req"),
    )
    .sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    )
    .slice()
    .map<HistoryItem>((item, index, sortedArray) => {
      const itemData = item.data as Extract<
        RideHistoryData,
        { type: "action" }
      >;
      let result: HistoryItem = {
        itemType: "item",
        type: itemData.action as any,
        createdAt: new Date(item.createdAt),
        secondsSincePreviousEvent: null,
        dataKey: itemData.action,
      };

      if (historyInfoType.indexOf(itemData.action) !== -1) {
        result.itemType = "info";
      }

      if (result.itemType === "item") {
        for (let i = index - 1; i >= 0; i--) {
          const previousItemData = sortedArray[i].data as Extract<
            RideHistoryData,
            { type: "action" }
          >;
          if (!historyInfoType.includes(previousItemData.action)) {
            result.secondsSincePreviousEvent = Math.abs(
              new Date(item.createdAt).getTime() -
                new Date(sortedArray[i].createdAt).getTime(),
            );
            break;
          }
        }
        // add motif for user_cancel_ride and driver_cancel_ride
        if (
          result.type === "user_cancel_ride" &&
          isNotEmpty((item.data as any)?.reason)
        ) {
          const reason =
            RidecancelReasonLabels[
              (item.data as any)?.reason as RidecancelReason
            ] ?? (item.data as any)?.reason;
          result.data = `Motif : ${reason}`;
        }
        if (
          result.type === "driver_cancel_ride" &&
          isNotEmpty((item.data as any)?.reason)
        ) {
          result.data = `Motif : ${(item.data as any)?.reason}`;
        }
        if (
          result.type === "found_driver" &&
          isNotEmpty((item.data as any)?.source)
        ) {
          result.data = `Mode d'acceptation : ${RideFoundDriverSourceLabels[(item.data as any)?.source as keyof typeof RideFoundDriverSourceLabels]}`;
        }
      } else if (result.itemType === "info") {
        const historyInfoData = item.data as Extract<
          RideHistoryData,
          { type: "action" }
        >;
        if (historyInfoData.action === "initiate_call") {
          result.dataKey = `${historyInfoData.action}_${historyInfoData.by}_${historyInfoData.callType}`;
        } else if (historyInfoData.action === "open_navigation_app") {
          result.dataKey = `${historyInfoData.action}_${historyInfoData.by}_${historyInfoData.navigationApp}`;
        }
        const previousItem = sortedArray[index - 1] as unknown as
          | HistoryItem
          | undefined;
        if (previousItem) {
          result.secondsSincePreviousEvent = Math.abs(
            new Date(item.createdAt).getTime() -
              new Date(previousItem.createdAt).getTime(),
          );
        }
      }

      return result;
    })
    .reverse();

  if (rideHistory?.[rideHistory.length - 2]?.itemType === "info") {
    const temp = rideHistory[rideHistory.length - 3];
    rideHistory[rideHistory.length - 3] = rideHistory[rideHistory.length - 2];
    rideHistory[rideHistory.length - 2] = temp;
  }

  return (
    <CCard className="timeline mb-4" style={{ width: "40%", height: "700px" }}>
      <CCardHeader className="bg-gradient-primary d-flex justify-content-between">
        <CNav variant="tabs" className="mb-0">
          <CNavItem
            className="p-0"
            href="#history"
            active={activeTab === 0}
            onClick={() => handleTabChange(0)}
          >
            <CNavLink
              className=" d-flex align-items-center gap-2 p-0"
              style={{ color: activeTab === 0 ? "orange" : "white" }}
            >
              <FontAwesomeIcon icon={faHistory} className="ms-2" />
              Historique du trajet
            </CNavLink>
          </CNavItem>
        </CNav>
        <CNav variant="tabs" className="mb-0">
          <CNavItem
            className="p-0"
            href="#driversReceiveRide"
            active={activeTab === 1}
            onClick={() => handleTabChange(1)}
          >
            <CNavLink
              className="d-flex align-items-center gap-2 p-0"
              style={{ color: activeTab === 1 ? "orange" : "white" }}
            >
              <FontAwesomeIcon icon={faTaxi} className="ms-2" />
              les chauffeurs reçoivent la course
            </CNavLink>
          </CNavItem>
        </CNav>
      </CCardHeader>

      <CCardBody
        className="p-3"
        style={{ overflowY: "auto", position: "relative" }}
        ref={(el) => {
          if (el) {
            const lineElement = el.querySelector(
              ".timeline-line",
            ) as HTMLElement;
            if (lineElement) {
              lineElement.style.height = `${el.scrollHeight - 40}px`;
            }
          }
        }}
      >
        {activeTab === 0 ? (
          <>
            {/* Continuous dashed line */}
            <div
              className="timeline-line"
              style={{
                position: "absolute",
                left: "45px",
                top: "20px",
                borderLeft: "2px dashed #ccc",
                width: "0px",
                zIndex: 1,
                height: "100px",
              }}
            />

            {rideHistory.map((historyItem, index) => {
              let eventInfo =
                eventPresentationInfo[
                  historyItem.dataKey as keyof typeof eventPresentationInfo
                ];
              let duration = formatRelativeTime(
                historyItem.secondsSincePreviousEvent ?? 0,
              );

              if (historyItem.itemType === "info") {
                return (
                  <CTooltip
                    content={`${formatDateString(historyItem.createdAt.toISOString())} - ${format(
                      historyItem.createdAt,
                      "HH:mm",
                    )}`}
                  >
                    <div
                      key={index}
                      className="d-flex justify-content-center mb-2"
                      style={{ position: "relative", zIndex: 2 }}
                    >
                      <span
                        style={{ color: "black" }}
                        className={`badge  px-3 py-2 d-flex align-items-center gap-1`}
                      >
                        <FontAwesomeIcon icon={eventInfo.icon} size="lg" />
                        {eventInfo.title}
                        <>
                          {duration && (
                            <div className="text-muted mt-1">
                              {duration} après
                            </div>
                          )}
                        </>
                      </span>
                    </div>
                  </CTooltip>
                );
              }

              return (
                <div
                  key={index}
                  className="d-flex align-items-start mb-4"
                  style={{ position: "relative", zIndex: 2 }}
                >
                  <div
                    className="d-flex flex-column align-items-center me-3"
                    style={{
                      minHeight: "70px",
                      position: "relative",
                      zIndex: 3,
                      backgroundColor: "white",
                      borderRadius: "50%",
                      padding: "8px",
                      width: "60px",
                      height: "60px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={eventInfo.icon}
                      size="xl"
                      className={`text-${eventInfo.color}`}
                    />
                  </div>
                  <div className="d-flex flex-column align-items-center w-100">
                    <div className="border rounded-3 p-2 w-100">
                      <h6 className="mb-0 fw-bold">{eventInfo.title}</h6>
                      {historyItem.data && (
                        <p className="mt-1 mb-0">{historyItem.data}</p>
                      )}
                      <small className="text-muted">
                        {`${formatDateString(historyItem.createdAt.toISOString())} - ${format(
                          historyItem.createdAt,
                          "HH:mm",
                        )}`}
                      </small>

                      {duration && (
                        <div
                          className="text-muted mt-1"
                          style={{ fontSize: "0.85rem" }}
                        >
                          ⏱️ {duration} après
                        </div>
                      )}

                      {eventInfo.description && (
                        <p className="mt-1 mb-0">{eventInfo.description}</p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div className="d-flex align-items-center gap-2">
                <CDropdown>
                  <CDropdownToggle color="white">
                    {onLine === null
                      ? `Tous (${foundDrivers.length})`
                      : onLine
                        ? "En ligne" +
                          `(${foundDrivers.filter((item) => item.isOnline).length})`
                        : "Hors ligne" +
                          `(${foundDrivers.filter((item) => !item.isOnline).length})`}
                  </CDropdownToggle>
                  <CDropdownMenu>
                    <CDropdownItem
                      active={onLine === null}
                      onClick={() => setOnLine(null)}
                    >
                      Tous({foundDrivers.length})
                    </CDropdownItem>
                    <CDropdownItem
                      active={onLine === true}
                      onClick={() => setOnLine(true)}
                    >
                      En ligne(
                      {foundDrivers.filter((item) => item.isOnline).length})
                    </CDropdownItem>
                    <CDropdownItem
                      active={onLine === false}
                      onClick={() => setOnLine(false)}
                    >
                      Hors ligne(
                      {foundDrivers.filter((item) => !item.isOnline).length})
                    </CDropdownItem>
                  </CDropdownMenu>
                </CDropdown>
              </div>
              <div className="d-flex align-items-center gap-2">
                Afficher les conducteurs sur la map :
                <CFormCheck
                  className="me-3"
                  checked={foundDrivers
                    .filter(
                      (item) => onLine === null || item.isOnline === onLine,
                    )
                    .every((item) => showDriversOnMap[item.driver.id])}
                  onChange={(e) => {
                    const newShowDriversOnMap = { ...showDriversOnMap };
                    foundDrivers
                      .filter(
                        (item) => onLine === null || item.isOnline === onLine,
                      )
                      .forEach((item) => {
                        newShowDriversOnMap[item.driver.id] = e.target.checked;
                      });
                    setShowDriversOnMap(newShowDriversOnMap);
                    onShowDriversOnMapChange?.(newShowDriversOnMap);
                  }}
                />
              </div>
            </div>
            <div className="mb-2">
              <CFormInput
                type="text"
                placeholder="Rechercher un conducteur"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                value={search}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    setSearch((e.target as HTMLInputElement).value);
                  }
                }}
              />
            </div>
            <div>
              <DriverInfo
                data={foundDrivers}
                search={search}
                onLine={onLine}
                ride={ride}
                showDriversOnMap={showDriversOnMap}
                handleShowDriversOnMap={handleShowDriversOnMap}
              />
            </div>
          </>
        )}
      </CCardBody>
    </CCard>
  );
};

export default RideHistoryTimeline;

function DriverInfo({
  data,
  search,
  onLine,
  ride,
  showDriversOnMap,
  handleShowDriversOnMap,
}: {
  data: RideDriverLog[];
  search: string;
  onLine: boolean | null;
  ride: Ride;
  showDriversOnMap: Record<string, boolean>;
  handleShowDriversOnMap: (driverId: string, checked: boolean) => void;
}) {
  const filteredData = data.filter((item) => {
    return (
      item.driver.fullName.toLowerCase().includes(search.toLowerCase()) &&
      (onLine === null || item.isOnline === onLine)
    );
  });
  const [expandedBoxes, setExpandedBoxes] = useState<Record<string, boolean>>(
    {},
  );
  const toggleBox = (id: string) =>
    setExpandedBoxes((s) => ({ ...s, [id]: !s[id] }));

  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className="text-center text-muted p-3">
        <p>Aucun conducteur trouvé pour ce trajet</p>
      </div>
    );
  }
  return map(filteredData, (item) => {
    return (
      <div
        className={` ${expandedBoxes[item.driver?.id] ? "" : ""} `}
        onClick={() => toggleBox(item.driver?.id)}
      >
        <div
          key={item.driver?.id}
          className="d-flex justify-content-between align-items-center py-2"
          style={{
            backgroundColor:
              ride.driver?.id === item.driver?.id ? "#f97b2226" : "white",
            paddingRight: "10px",
          }}
        >
          <CTableDataCell className="px-3 text-sm">
            <div className="d-flex align-items-center gap-3">
              <div className="d-flex flex-column gap-2">
                <ProfilePictureAvatar
                  profilePicture={item.driver?.profilePicture}
                  fullName={item.driver?.fullName}
                />
                <div
                  className={`flex items-center gap-1 px-2 py-1 rounded-full `}
                  style={
                    item.retryCount === 0
                      ? {
                          backgroundColor: "#dcfce7",
                          border: "1px solid #40ae40",
                        }
                      : item.retryCount === 1
                        ? {
                            backgroundColor: "#fef9c3",
                            border: "1px solid #ffb800",
                          }
                        : {
                            backgroundColor: "#ffe3e3",
                            border: "1px solid #dc3545",
                          }
                  }
                >
                  <span className={`text-xs font-semibold text-black `}>
                    {item.retryCount === 0 ? (
                      <>
                        <span>1</span>
                        <sup>er</sup> <span>essai</span>{" "}
                      </>
                    ) : (
                      <>
                        <span>{item.retryCount + 1}</span>
                        <sup>ème</sup> <span>essai</span>{" "}
                      </>
                    )}
                  </span>
                </div>
              </div>
              <div>
                <Link
                  to={`/drivers/${item.driver?.id}`}
                  className="fw-bold m-0"
                >
                  {item.driver?.fullName}
                </Link>
                <div className="m-0">
                  {item.isOnline ? (
                    <div className="d-flex align-items-center gap-2">
                      <FontAwesomeIcon
                        icon={faCircle}
                        className="text-success"
                      />
                      En ligne
                    </div>
                  ) : (
                    <div className="d-flex align-items-center gap-2">
                      <FontAwesomeIcon icon={faCircle} className="text-red" />
                      Hors ligne
                    </div>
                  )}
                </div>
                {expandedBoxes[item.driver?.id] ? (
                  <div className="pt-2">
                    <span className="text-black d-flex align-items-center gap-2">
                      {item.createdAt != null ? (
                        <>
                          <FontAwesomeIcon icon={faPaperPlane} />
                          {formatDateStringWithTime(item.createdAt)}
                          {` ⏱️ `}
                          {formatRelativeTime(
                            new Date(item.createdAt).getTime() -
                              new Date(ride.createdAt).getTime(),
                          )}
                        </>
                      ) : null}
                    </span>
                    <span className="text-black d-flex align-items-center gap-2">
                      {item.seenAt != null ? (
                        <div className="d-flex flex-column align-items-center">
                          <div className="d-flex align-items-center gap-2">
                            <FontAwesomeIcon
                              icon={faEye}
                              className="text-primary"
                            />
                            {formatDateStringWithTime(item.seenAt)}
                            {` ⏱️ `}
                            {formatRelativeTime(
                              new Date(item.seenAt).getTime() -
                                new Date(item.createdAt).getTime(),
                            )}
                          </div>
                          <small className="text-muted">
                            (
                            {item?.status == "in_app_viewed"
                              ? "Vu dans l'app"
                              : item?.status == "overlay_viewed"
                                ? "Vu dans la pop-up"
                                : null}
                            )
                          </small>
                        </div>
                      ) : null}
                    </span>
                    <span className="text-black d-flex align-items-center gap-2">
                      {item.refusedAt != null ? (
                        <div className="d-flex flex-column align-items-center">
                          <div className="d-flex align-items-center gap-2">
                            <FontAwesomeIcon
                              icon={faXmark}
                              className="text-red text-md"
                            />
                            {formatDateStringWithTime(item.refusedAt)}
                            {` ⏱️ `}
                            {formatRelativeTime(
                              new Date(item.refusedAt).getTime() -
                                new Date(
                                  item.seenAt ?? item.createdAt,
                                ).getTime(),
                            )}
                          </div>
                          <small className="text-muted">
                            (
                            {item?.status == "overlay_refused"
                              ? "Refusé dans la pop-up"
                              : item?.status == "in_app_refused"
                                ? "Refusé dans l'app"
                                : null}
                            )
                          </small>
                        </div>
                      ) : null}
                    </span>
                  </div>
                ) : (
                  <div className="d-flex column align-items-center gap-2 border border-black rounded-3 p-1 w-fit">
                    <span className="text-black">
                      {item.createdAt != null ? (
                        <>
                          <FontAwesomeIcon icon={faPaperPlane} />
                        </>
                      ) : null}
                    </span>
                    <span className="text-black">
                      {item.seenAt != null ? (
                        <FontAwesomeIcon
                          icon={faEye}
                          className="text-primary"
                        />
                      ) : null}
                    </span>
                    <span className="text-black">
                      {item.refusedAt != null ? (
                        <FontAwesomeIcon
                          icon={faXmark}
                          className="text-red text-md"
                        />
                      ) : null}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </CTableDataCell>
          <div>
            <span className="d-flex align-items-center gap-2">
              Afficher :
              <CFormCheck
                className="me-3"
                defaultChecked={showDriversOnMap[item.driver?.id]}
                onChange={(e) => {
                  handleShowDriversOnMap(item.driver?.id, e.target.checked);
                }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent the click from bubbling up to parent div
                }}
              />
            </span>
          </div>
        </div>
        <div className="w-100" style={{ borderBottom: "1px solid #ccc" }} />
      </div>
    );
  });
}
